import { useEffect, useRef } from 'react';

export const useEffectWithoutInitial = (fn, inputs): void => {
  const didMountRef = useRef(false);

  useEffect(() => {
    if (didMountRef.current) {
      return fn();
    }
    didMountRef.current = true;
  }, inputs);
};
